import { createLocalStorageStateHook } from 'use-local-storage-state'

import { listView } from '../constants/ui'

const useViewMode = createLocalStorageStateHook(
  'ellii-search-viewMode',
  listView
)

export default useViewMode
